// Single source of truth for which deck-hosting sites we accept imports
// from, and for pre-flight validation of a candidate import URL. Used by
// the submit form and the ?ingest= deep-link flow so both surfaces accept
// exactly the same URLs and emit the same error copy.

export const SUPPORTED_SITES = [
    { host: 'moxfield.com/', label: 'moxfield.com' },
    { host: 'archidekt.com/', label: 'archidekt.com' },
    { host: 'tappedout.net/', label: 'tappedout.net' },
    { host: 'manabox.app/', label: 'manabox.app' },
    // { host: 'mtggoldfish.com/', label: 'mtggoldfish.com' },
    { host: 'scryfall.com/', label: 'scryfall.com' },
    { host: 'topdecked.com/', label: 'topdecked.com' },
    { host: 'topdeck.gg/', label: 'topdeck.gg' },
    { host: 'hareruyamtg.com/', label: 'hareruyamtg.com' },
    { host: 'commanderview.app/', label: 'commanderview.app' },
];

const UNSUPPORTED_PATHS = [
    { pattern: /archidekt\.com\/folders/, message: 'Folder URIs not supported' },
    { pattern: /archidekt\.com\/compare/, message: 'Compare URIs not supported' },
    { pattern: /archidekt\.com\/articles/, message: 'Sandbox URIs not supported' },
    { pattern: /archidekt\.com\/snapshots/, message: 'Snapshot URIs not supported' },
    { pattern: /archidekt\.com\/sandbox/, message: 'Sandbox URIs not supported' },
    { pattern: /archidekt\.com\/search/, message: 'Search URIs not supported' },
    // { pattern: /mtggoldfish\.com\/articles/, message: 'MTGGoldfish articles not supported' },
    { pattern: /\/playtest/, message: 'Playtest URIs not supported' },
];

// Returns an error message when the URL can't be imported, or null when
// it's good to send to the backend.
export function validateDeckImportUrl(url) {
    const cleaned = url ? url.trim() : '';
    if (!cleaned) return 'No deck URL provided';

    for (const { pattern, message } of UNSUPPORTED_PATHS) {
        if (pattern.test(cleaned)) return message;
    }

    const hostHit = SUPPORTED_SITES.some(({ host }) => cleaned.includes(host));
    if (!hostHit) {
        return `Sorry, we currently only accept deck lists from ${SUPPORTED_SITES.slice(0, -1)
            .map((s) => s.label)
            .join(', ')}, and ${SUPPORTED_SITES[SUPPORTED_SITES.length - 1].label}.`;
    }

    return null;
}
